import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Patient, PatientMinimum } from 'src/app/core/model/patient';
import { UtilsService } from 'src/app/core/services/v2/utils.service';
import { PatientService } from 'src/app/patients/patients.service';
import { PhysicianOptionService } from 'src/app/physician/shared/physician-option/physician-option.service';
import { MyErrorStateMatcher } from 'src/app/shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-add-new-member',
  templateUrl: './add-new-member.component.html',
  styleUrls: ['./add-new-member.component.scss']
})
export class AddNewMemberComponent  implements OnInit {
  employerId: any;
  constructor(
    private patientsService: PatientService,
    private physicianOptionService: PhysicianOptionService,
    public matDialogRef: MatDialogRef<AddNewMemberComponent>,    
    private loaderService: WindowLoaderService,
    private utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any // Inject the data her
 
  ) {}

  @Input() specialistId: number;
  @Input() title : string ="Create New Member"; 
  @Output() save: EventEmitter<Patient> = new EventEmitter();
  @ViewChild("fileInput", { static: true }) fileInput;
  @ViewChild("fileInput2", { static: true }) fileInput2;

  patientCreated: boolean;
  patient: PatientMinimum;
  createdPatient: any;
  errorUnverifiedNumber: boolean = false;
  maxDate: Date = new Date();

  matcher = new MyErrorStateMatcher();

  firstNameFormControl = new FormControl("", [Validators.required]);
  middleNameFormControl = new FormControl("", []);
  lastNameFormControl = new FormControl("", [Validators.required]);
  preferredNameFormControl = new FormControl("", []);
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  mobileContactNumberFormControl = new FormControl("", [Validators.required]);
  workContactNumberFormControl = new FormControl("", []);
  sexFormControl = new FormControl("", [Validators.required]);
  dobFormControl = new FormControl("", [Validators.required]);

  dataForm: FormGroup = new FormGroup({
    firstname: this.firstNameFormControl,
    middlename: this.middleNameFormControl,
    lastname: this.lastNameFormControl,
    email: this.emailFormControl,
    sex: this.sexFormControl,
    dob: this.dobFormControl,
    phone: this.mobileContactNumberFormControl,
    secphone: this.workContactNumberFormControl,
  });

  ngOnInit() {
    this.patient = <PatientMinimum>{};
  }

  onNoClick(): void {}

  onSubmit(patient: PatientMinimum): void {
    if (this.dataForm.invalid) {
      return;
    }
    this.employerId = this.data.id;
    if(this.employerId > 0)
      patient.employerId = this.employerId;
    patient.practitionerId = this.physicianOptionService.getPhysician().id;
    patient.gender = patient.sex;
    this.loaderService.show();
    this.patientsService.createMinimumnPatient(patient).subscribe(
      (p) => {
        // this.createdPatient = p;
        // this.patientCreated = true;
        // this.save.emit(p);
        this.loaderService.hide();
        const title = this.employerId > 0 ? 'New employee created successfully.': 'New member created successfully.'
        this.utils.showMessageSnackBar(title);
        this.matDialogRef.close(true);
      },
      (error) => {
        this.utils.showMessageSnackBar('Something went wrong, please try again later.', true);
        this.loaderService.hide();
      }
    );
  }

  cancel() {
    this.patientCreated = false;
    this.matDialogRef.close(false);
    // this.save.emit(null);
  }
}
